import createRoute       from '@widesk-ui/tools/createRoute';
import MobileSliderModel from '@models/website/MobileSliderModel';

const route = createRoute.splitView(
	'/website_entertainments/:websiteEntertainmentId/mobile_sliders',
	'website',
	'MobileSliderSplitView',
	MobileSliderModel.localize('plural'),
);
export default route;
